import { cn } from "@/utils/cn";
import FilledButton from "../filled-button";

type SaveButtonPosition = "fixed" | "static";
interface SaveButtonProps {
  text: string;
  type?: "submit" | "button";
  onSave?: () => void;
  disabled?: boolean;
  position?: SaveButtonPosition;
  className?: string;
}

const positionStyle: Record<SaveButtonPosition, string> = {
  fixed: "fixed bottom-8 left-4 right-4 z-10",
  static: "static pb-safe-offset-8",
};

export default function SaveButton({
  text,
  type = "button",
  onSave,
  disabled,
  position = "static",
  className,
}: SaveButtonProps) {
  return (
    <FilledButton
      text={text}
      onClick={onSave}
      type={type}
      color="dark"
      disabled={disabled}
      className={cn(
        "max-w-[420px] mx-auto",
        {
          [positionStyle.fixed]: position === "fixed",
          [positionStyle.static]: position === "static",
        },
        className,
      )}
    />
  );
}
